<template>
    <div style="width:100%;" v-if="$parent.isDetailsClick">

        <div class="" v-if="orderData != null">
            <div class="order_history_title">
                <div class="main_text">
                    {{orderData.shopInfo['name'+getItemSubfix()]}}
                </div>
                <div class="sub_text">
                    <div class="order_date">{{$root.orderDateTimeDisplay(orderData.orderDate)}}</div>
                    <div class="order_status" :style="{'color':orderData['statusColor']}">{{orderData['statusText'+getItemSubfix()]}}</div>
                </div>
            </div>

            <div class="order_details_main_div">

                <div class="order_success_area">
                    <!--<div class="order_success_order_no">
                        <div class="order_success_order_no_row">
                            <div class="order_no_text_title">{{label['conformation_success_order_no_text']}}:</div>
                            <div class="order_no_text_sign"></div>
                        </div>
                        <div class="order_success_order_no_row">
                            <div class="order_no_text_orderno">{{orderData.orderNo}}</div>
                        </div>
                    </div>-->
                    <div class="order_success_order_no">
                        <div class="order_success_order_no_row">
                            <div class="order_no_text_title">{{label['conformation_success_order_from_shop_text']}}:</div>
                            <div class="order_no_text_sign"></div>
                        </div>
                        <div class="order_success_order_no_row">
                            <div class="order_no_text_orderno">{{displayShop['name'+getItemSubfix()]}}</div>
                        </div>
                    </div>

                    <div class="order_success_order_no pickup" v-if="
                         ((order.order.status == 'send' || order.order.status == 'pending' || order.order.status == 'complete') && order.order.orderMode != 'shopping') ||
                         ((order.order.status == 'send' || order.order.status == 'pending' || order.order.status == 'complete') && (order.order.pickupShopStatus == 'ready_for_pickup' || order.order.pickupShopStatus == 'picked_up') && order.order.orderMode == 'shopping')">
                        <div class="order_success_order_no_row">
                            <div class="order_no_text_title" v-if="order.order.orderMode != 'shopping'">{{label['conformation_success_pickup_no_text']}}:</div>
                            <div class="order_no_text_title" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 2 && order.order.orderMode != 'shopping'">{{label['conformation_success_pickup_no_text']}}:</div>
                            <div class="order_no_text_title" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 2 && order.order.orderMode == 'shopping'">{{label['conformation_success_pickupShop_no_text']}}:</div>
                            <div class="order_no_text_title" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 3">{{label['conformation_success_pickupShop_no_text']}}:</div>
                            <div class="order_no_text_sign"></div>
                        </div>
                        <div class="order_success_order_no_row">
                            <div class="order_no_text_pickup">{{pickUpNo}}</div>
                        </div>
                    </div>
                </div>

                <div class="order_details_area_div">
                    <div class="order_details_area_div_1">

                        <div class="order_data_area">
                            <div class="order_data_row order_type full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 1">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title" v-if="order.order.orderMode != 'shopping'">{{label['order_history_order_details_order_type_text']}}</div>
                                        <div class="order_data_title" v-if="order.order.orderMode == 'shopping'">{{label['order_history_order_details_order_type_shopping_text']}}</div>
                                        <div class="order_data_content_a">{{$root.GetOrderModePickupTypeLabel(1,order.order.orderMode)}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="order_data_row order_type full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 2">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title" v-if="order.order.orderMode != 'shopping'">{{label['order_history_order_details_order_type_text']}}</div>
                                        <div class="order_data_title" v-if="order.order.orderMode == 'shopping'">{{label['order_history_order_details_order_type_shopping_text']}}</div>
                                        <div class="order_data_content_a">{{$root.GetOrderModePickupTypeLabel(2,order.order.orderMode)}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="order_data_row order_type full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 3">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['order_history_order_details_order_type_shopping_text']}}</div>
                                        <div class="order_data_content_a">{{$root.GetOrderModePickupTypeLabel(3,order.order.orderMode)}}</div>
                                    </div>
                                </div>
                            </div>

                            <!--
                            <div class="order_data_row whatsapp" v-if="$root.isWhatsApp">
                                <div class="order_data_tag_inner_div" @click="$root.openWhatsAppMessageURL(order.order)">
                                <div class="order_data_tag_inner_div" onclick="window.open('whatsapp://send?phone=38501410');">
                                <a href="https://wa.me/38501410" target="_blank">
                                <a href="nftouchuat://externalappbrowser?url=whatsapp%3A%2F%2Fsend%3Fphone%3D%2B85238501410" target="_blank" v-if="$root.NFExternalAppBrowser = 'uat'">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                    </div>
                                </a>
                                <a href="nftouch://externalappbrowser?url=whatsapp%3A%2F%2Fsend%3Fphone%3D%2B85238501410" target="_blank" v-if="$root.NFExternalAppBrowser != 'uat'">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                    </div>
                                </a>
                            </div>
                            <div class="order_data_row whatsapp hotline" v-if="!$root.isWhatsApp">
                                <a :href="'tel:'+$root.whatsappNo">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                    </div>
                                </a>
                            </div>
                            -->
                            <!--
                            <div class="order_data_row whatsapp whatsapp" v-if="info.order_temp_info.order_device == 'ios'">
                                <a href="https://wa.me/85238501410" target="_blank">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                    </div>
                                </a>
                            </div>
                            <div class="order_data_row whatsapp whatsapp" v-if="info.order_temp_info.order_device != 'ios'">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}} 38501410</div>
                                    </div>
                            </div>
                            -->
                            <!--
                            <div class="order_data_row whatsapp" v-if="$root.isWhatsApp">
                                <div class="order_data_tag_inner_div" @click="$root.openWhatsAppMessageURL(order.order)">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                </div>
                            </div>
                            <div class="order_data_row whatsapp hotline" v-if="!$root.isWhatsApp">
                                <a :href="'tel:'+$root.whatsappNo">
                                    <div class="order_data_tag_inner_div">
                                        <div class="tag_icon"></div>
                                        <div class="tag_content">{{label['common_text_whatsapp_need_accistance']}}</div>
                                    </div>
                                </a>
                            </div>
                            -->
                            <div class="order_data_row delivery_date">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title" v-if="order.order.orderMode != 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 1">{{label['conformation_success_ready_datetime_text_delivery']}}</div>
                                        <div class="order_data_title" v-if="order.order.orderMode != 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2">{{label['conformation_success_ready_datetime_text_pickup']}}</div>
                                        <div class="order_data_title" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 1">{{label['conformation_success_ready_datetime_shopping_text_delivery']}}</div>
                                        <div class="order_data_title" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2">{{label['conformation_success_ready_datetime_shopping_text_pickup']}}</div>
                                        <div class="order_data_title" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 3">{{label['conformation_success_ready_datetime_shopping_text_pickup']}}</div>

                                        <div class="order_data_content_a" v-if="order.order.orderMode != 'shopping'" v-html="$root.displayOrderDateTime(order.order.readyTime, true)"></div>
                                        <!--<div class="order_data_content_a" v-if="order.order.orderMode == 'shopping'" v-html="$root.displayOrderDateTime(order.order.readyTime, true, false)"></div>-->
                                        <div class="order_data_content_a" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2" v-html="label['checkout_orderType_pickup_time_text']"></div>
                                        <div class="order_data_content_a" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 3" v-html="label['checkout_orderType_pickupShop_time_text']"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="order_data_row online_order_no">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['conformation_success_online_order_number']}}</div>
                                        <div class="order_data_content_a">{{order.order.orderNo}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="order_data_row username">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['member_profile_member_name_text']}}</div>
                                        <div class="order_data_content_a">{{order.order.name}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="order_data_row phone">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['member_profile_member_tel_text']}}</div>
                                        <div class="order_data_content_a">+{{order.order.phone_countryCode}}-{{order.order.phoneHide}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="order_data_row shop full" v-if="order.order.orderMode != 'shopping'">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['conformation_success_order_shop_text']}}</div>
                                        <div class="order_data_content_b">{{displayShop['name'+getItemSubfix()]}}</div>
                                        <div class="order_data_content_c">{{displayShop['address'+getItemSubfix()]}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="order_data_row order_type full" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['order_mode_pickup_type_pickup_text_'+order.order.orderMode]}}</div>
                                        <div class="order_data_content_c" v-html="$root.ContentNewLineHtmlReplace(order.order['address_full_'+getItemSubfix()])"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="order_data_row order_type full" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 3">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['conformation_success_order_shop_text']}}</div>
                                        <div class="order_data_content_b">{{order.order.pickupShop['name'+getItemSubfix()]}}</div>
                                        <div class="order_data_content_c">{{order.order.pickupShop['address'+getItemSubfix()]}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="order_data_row address full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 1">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title" v-if="order.order.orderMode != 'shopping'">{{label['conformation_success_delivery_address_header_text']}}</div>
                                        <div class="order_data_title" v-if="order.order.orderMode == 'shopping'">{{label['conformation_success_delivery_address_header_text_shopping']}}</div>
                                        <div class="order_data_content_c" v-html="$root.ContentNewLineHtmlReplace(order.order['address_full_'+getItemSubfix()])"></div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="order_data_row coupon full" v-if="order.order.coupons.length > 0">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['checkout_order_use_coupon_header_text']}}</div>
                                        <div class="order_data_content_a"
                                            v-for="(coup, index) in order.order.coupons">{{coup.couponName}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="order_data_row coupon full" v-if="order.order.couponCode != ''">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['checkout_order_use_discount_code_header_text']}}</div>
                                        <div class="order_data_content_a">{{order.order.couponCode}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="order_data_row DeliveryMessage full" v-if="$root.displayOrderDeliveryMessage(order) != ''">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['checkout_delivery_remark_text']}}</div>
                                        <div class="order_data_content_a" v-html="$root.displayOrderDeliveryMessage(order)"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="order_data_row OrderRemarks full" v-if="$root.displayOrderRemarks(order) != ''">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['checkout_order_remark_text']}}</div>
                                        <div class="order_data_content_a" v-html="$root.displayOrderRemarks(order)"></div>
                                    </div>
                                </div>
                            </div>

                            <!--<div class="order_data_row delivery_date full">
                                <div class="order_data_tag_inner_div">
                                    <div class="tag_icon"></div>
                                    <div class="tag_content">
                                        <div class="order_data_title">{{label['conformation_success_create_datetime_text']}}</div>
                                        <div class="order_data_content_a">{{$root.orderDateTimeDisplay(order.order.orderDate)}}</div>
                                    </div>
                                </div>
                            </div>-->

                        </div>

                    </div>

                    <div class="order_details_area_div_2">

                        <div class="order_items_area">
                            <div class="order_items_list_header">{{label['conformation_success_order_data_header_text']}}</div>
                            <div class="order_items_list_area">                    
                            
                                <CartListItem v-bind:cart="order.order" v-bind:can_update="false">
                                </CartListItem>
                            
                            </div>
                        </div>

                        <div class="order_payment_area" v-if="order.order.payments != undefined && order.order.payments.length > 0">
                            <div class="order_payment_area_header">{{label['checkout_payment_method_header_text']}}</div>
                            <div class="order_payment_area_content">
                                <div class="order_payment_text">
                                    <div class="text_div">{{ getPayMethodObj(order.order.payments[0])["name" + getItemSubfix()] }}</div>
                                    <div class="icon_div master_card" v-if="getPayMethodObj(order.order.payments[0])['code'] == 'cybersource'"><img src="/files/images/main/payment_ico_master.png" align="absmiddle" /></div>
                                    <div class="icon_div visa_card" v-if="getPayMethodObj(order.order.payments[0])['code'] == 'cybersource'"><img src="/files/images/main/payment_ico_visa_secure.png" align="absmiddle" /></div>
                                </div>
                                <div class="order_payment_icon" :style="{'background-image':'url(\''+getPayMethodObj(order.order.payments[0])['image']+'\')'}"></div>
                            </div>
                        </div>

                        <div class="order_amount_area">

                            <div class="order_amount_row">
                                <div class="price_text">{{label['amount_label']}}</div>
                                <div class="price_amount">
                                    <!--<money :price="$root.sumItemListPrice(order.order.items)" />-->
                                    <money :price="order.order.amountWithoutDiscount" />
                                </div>
                            </div>

                            <div class="order_amount_row isAlert" v-if="order.order.minCharge > 0">
                                <div class="price_text">{{label['cart_fit_minCharge_text']}}</div>
                                <div class="price_amount">
                                    <money :price="order.order.minCharge" />
                                </div>
                            </div>

                            <div class="order_amount_row" v-if="order.order.packingCharge > 0">
                                <div class="price_text">{{label['cart_packingCharge_text']}}</div>
                                <div class="price_amount">
                                    <money :price="order.order.packingCharge" />
                                </div>
                            </div>                            

                            <!-- load discount item start -->
                            <div class="order_amount_row"
                                    v-for="(discount, index) in order.order.discounts.filter(x => !x.isHide)"
                                    :key="'d'+index">
                                <div class="price_text">{{discount['name'+getItemSubfix()]}}</div>
                                <div class="price_amount">
                                    -<money :price="discount.price" />
                                </div>
                            </div>
                            <!-- load discount item end -->

                            <div class="order_amount_row" v-if="order.order.deliveryCharge > 0">
                                <div class="price_text">{{label['cart_deliveryCharge_text']}}</div>
                                <div class="price_amount">
                                    <money :price="order.order.deliveryCharge" />
                                </div>
                            </div>

                            <div class="order_amount_row" v-if="order.order.usedECash > 0">
                                <div class="price_text">{{label['checkout_order_use_ecash_text_used_ecash']}}</div>
                                <div class="price_amount">
                                    -<money :price="order.order.usedECash" />
                                </div>
                            </div>

                            <!--<div class="order_amount_row final_amount">                                    
                                <div class="price_text">{{label['total_amount_need_pay_label']}}</div>
                                <div class="price_amount">
                                    <money :price="order.order.amount" />
                                </div>
                            </div>-->

                        </div>

                        <div class="order_amount_area no_border no_top">

                            <div class="order_amount_row final_amount">
                                <div class="price_text">{{label['total_amount_label']}}</div>
                                <div class="price_amount">
                                    <money :price="order.order.amount" />
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div> 
        </div>
        <!-- orderNo != null -->

        <div class="" v-if="orderData == null">
            <div class="order_history_title">{{label['order_history_page_order_not_found_header_text']}}</div>
        </div>
        <!-- orderNo == null -->


    </div>
</template>

<script>onabort
    import CartListItem from "../components/CartListItem.vue";

    export default {
        data() {
            return {
                orderData: null,
                orderNo: undefined,
                order: {
                    order:null
                },

                displayShop: null,

            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            cart() {
                return this.$root.cart;
            },
            member() {
                return this.$root.cart.member;
            },
            pickUpNo() {
                //return (this.orderData != null && this.orderData.orderNo != "") ? this.orderData.orderNo.substring(this.orderData.orderNo.length - 4) : "";
                return (this.orderData != null && this.orderData.orderNo != "") ? this.order.order.pickUpNo : "";
            },  
        },
        components: { CartListItem },
        created() {
            if (this.$route.params.orderNo == undefined) {
                this.$router.push(`/member/orderhistory`);
                return;
            }
            else {
                this.$parent.isDetailsClick = true; // for go page directly
                this.orderNo = this.$route.params.orderNo;
            }

            //this.info.loading = false;           
            this.$root.getCurrentPathName();

            if (!this.info.allowGuestMode) {
                if (this.member == null) {
                    this.$root.page_after_login = this.info.currentPathName;
                    this.$router.push("/guestlogin");
                }
            }

            this.$root.setGoBackAction(this.goBack);
        },
        destroyed() {
            this.resetOrderDetaisData();
            this.$root.setGoBackAction();
        },
        mounted() {
            this.initOrderDetails();
        },
        methods: {
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },   

            initOrderDetails() {
                // check contains member order data
                if (this.$parent.orderList == null) {
                    setTimeout(this.initOrderDetails, 100);
                }
                else {                    
                    this.OrderDetailsNoFilter(this.$parent.orderList);
                }
            },
            OrderDetailsNoFilter(orderList) {
                var app = this;
                var temp_order = orderList.filter(o => o.orderNo == app.orderNo);
                if (temp_order.length > 0) {
                    app.orderData = temp_order[0];
                    app.order.order = app.orderData;
                    app.displayShop = app.$root.getShopInfo(app.orderData.shop.shopCode);
                    if (app.displayShop == null) {
                        app.displayShop = app.orderData.shop;
                    }
                    //this.setOrderDetailsNoQRCode();
                }
            },
            setOrderDetailsNoQRCode() {
                //console.log("this.$refs.orderNo_qrcode", this.$refs.orderNo_qrcode);
                if (this.$refs.orderNo_qrcode) {
                    new QRCode(this.$refs.orderNo_qrcode, {
                        text: this.orderData.orderNo,
                        width: 320,
                        height: 320,
                        colorDark: "#000000",
                        colorLight: "#ffffff",
                        correctLevel: QRCode.CorrectLevel.H,
                    });
                }
                else {
                    setTimeout(this.setOrderDetailsNoQRCode, 100);
                }
            },

            goBack() {
                this.resetOrderDetaisData();
                //this.$router.push(`/member/orderhistory`);
                this.$router.go(-1);
                return true;
            },
            resetOrderDetaisData() {
                this.orderData = null;
                this.orderNo = undefined;
                this.order.order = null;
                this.$parent.isDetailsClick = false;
            },
            getPayMethodObj(method_obj) {
                var m = this.$parent.payMethodList.filter(a => a.code == method_obj.code);
                if (m.length > 0) {
                    return m[0];
                }
                else {
                    return method_obj
                }
            },


        },
    };
</script>
